import { Centred, Contents, RichText, MainFloat, Topper,Page, Margins } from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme),
    background: '#fff'
  },
  contents: {
    ...Contents(theme),
    background: '#fff',
    maxWidth: 1200,
    padding: '0 1.5rem 0 1.5rem'
  },
  text: {
    ...RichText(theme),
  },
  mainFloat: {
    marginTop: '-30%',
    position: 'relative',
  },
  page: {
    ...Page(theme),
  },
  margins: {
    ...Margins(theme),
  },
  topper: {
    ...Topper(theme),
    '& h1': {
      textTransform: 'uppercase',
      fontWeight: 800,
      lineHeight: 1,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.headline.fontSize,
        wordBreak: 'break-word',
      },
    },
    '& p': {
      textTransform: 'uppercase',
    }
  },


  lead: {
    padding: '0rem 7rem 0 7rem',
    maxWidth: 1024,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },

  layout: {
    padding: '3rem 7rem 0 7rem',
    maxWidth: 1024,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/method/styles.js